
import {customFetcher} from "./customFetcher";
import {IAccountStatus} from "../Interfaces/IAccountStatus";
import {useQuery} from "@tanstack/react-query";

export const useGetAccountStatus = () => {
    const { data: statusArray, isLoading: isLoadingStatusArray } = useQuery<IAccountStatus[]>({
        refetchOnWindowFocus: false,
        queryKey: ['accountStatus'],
        queryFn: () => customFetcher({ endpoint: '/status/' }),
        initialData: [], // Initiales leeres Array
    });

    return { statusArray, isLoadingStatusArray };
};